<div fxLayout="row" fxLayoutGap="5px">
    <div>
        <form [formGroup]="PrijscorrectieArtikelFormGroup">
            <br>
            <mat-card class="dashboard-card">
                <mat-card-header>
                    <mat-card-title>Prijscorrectie</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <br>
                    <mg-simple-form-section title="Artikelen">
                        <mg-simple-form-row>
                            <span mg-colspan-3>          
                                <mat-form-field pd-size-22>
                                    <mg-autocomplete #ArtikelgroepIDAutocomplete placeholder="Artikelgroep" formControlName="artikelgroepID" [getData]="getArtikelGroepDataSource" [disabled]="this.PrijscorrectieArtikelFormGroup.controls.alles.value"></mg-autocomplete>
                                </mat-form-field>
                            </span>
                        </mg-simple-form-row>
                        <mg-simple-form-row>
                            <span>
                                <mat-slide-toggle color="accent" formControlName="alles">Alle Artikelen</mat-slide-toggle>
                            </span>
                        </mg-simple-form-row>
                    </mg-simple-form-section>
                    
                    <mg-simple-form-section title="Prijzen">
                      <mg-simple-form-row>
                        <span>
                          <mat-form-field>
                            <input type="number" placeholder="Percentage" matInput formControlName="percentage">
                          </mat-form-field>
                        </span>
                      </mg-simple-form-row>
                    </mg-simple-form-section>

                    <br>
                    <div class="button">
                        <button mat-button (click)="this.PrijscorrectieArtikel()">Start Prijscorrectie</button>
                    </div>
                    <br>                    
                </mat-card-content>
            </mat-card>
        </form>

    </div>    
</div>
